import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from "react-router"
import style from "./component.module.sass";
import search from '../../../../../assets/images/searchicon.png';
import { Icon, Collapse, Tabs, Tooltip } from 'antd';
import { useDrag } from 'react-dnd';
import ItemTypes from './ItemTypes';
// import { ItemTypes } from "../create_v2/utils/item-types"
import { components } from './rendererJson'
import Tree from './Tree';
import { AssetTooltip } from './assetTooltip';
// import {assetsMode} from '../../../../stateManager/store/assets/action';

// import { ReactComponent as PropertyIcon } from '../../../../assets/svg/formIcons/Properties.svg';
// import { ReactComponent as ValidationIcon } from '../../../../assets/svg/formIcons/Validation.svg'
// import { ReactComponent as DataIcon } from '../../../../assets/svg/formIcons/Data.svg'

import { ReactComponent as Component } from '../../../../../assets/svg/formIcons/components.svg'
import { ReactComponent as Folder } from '../../../../../assets/svg/formIcons/folder.svg'
import { ReactComponent as Layer } from '../../../../../assets/svg/formIcons/layers.svg'
import { ReactComponent as ComponentLight } from '../../../../../assets/svg/formIcons/componentsOutline.svg'
import { ReactComponent as FolderLight } from '../../../../../assets/svg/formIcons/folderOutline.svg'
import { ReactComponent as LayerLight } from '../../../../../assets/svg/formIcons/layersOutline.svg'
import { ReactComponent as MoreIcon } from "../../../../../assets/svg/more.svg";
import "./styles/assets.style.scss";


const { Panel } = Collapse;
const { TabPane } = Tabs

interface Props {
    canEdit: boolean;
    selectedAppType: string;
}

const Components: React.FC<Props> = ({ canEdit, selectedAppType }) => {
    const params: any = useParams();
    const { formId } = params;
    const products = useSelector((state: any) => state.product);
    const { list: assets, assetEditMode } = useSelector((state: any) => state.assets);
    const [filteredComponenteList, setFilteredComponentList] = useState<any>({});
    const [list, setList] = useState<any>({});
    const [activeTab, setActiveTab] = useState("1");
    const [selectedId, setSelectedId] = useState<any>(null);
    const [selectedAssetEditId, setSelectedAssetEditId] = useState<any>(null);

    useEffect(() => {
        let filteredComponents: any = {};
        if (selectedAppType === "a8assist") {
            Object.keys(components).forEach((compType: any) => {
                let componentList: any[] = components[compType];
                let nonChatComponents = ["uploader", "otp", "scanner", "documentCollector"];
                let newcomponentList = componentList.filter(x => !nonChatComponents.includes(x.id))

                if (newcomponentList.length > 0) {
                    filteredComponents[compType] = [...newcomponentList]
                }
            })
        } else {
            filteredComponents = { ...components };
        }
        setFilteredComponentList(filteredComponents)
        setList(filteredComponents)
    }, [selectedAppType])

    useEffect(() => {
        const importedWidgets = (products[formId] && products[formId].widgets) || [];
        const importedPackages = (products[formId] && products[formId].packages) || {};
        setFilteredComponentList((prevState: any) => ({
            ...prevState,
            ...importedPackages,
            Widgets: importedWidgets,
        }));
        // handling for packages and widgets
        setList((prevState: any) => {
            const newState = { ...prevState };
            Object.keys(newState).forEach(key => {
                if ((key === 'Widgets' || key === 'basic' || key === 'advanced' || key === 'special' || key === 'GeneratingAI') 
                    && importedPackages[key]) {
                    return;
                } else if (key !== 'Widgets' && key !== 'basic' && key !== 'advanced' && key !== 'special' && key !== 'GeneratingAI' && !importedPackages[key]) {
                    delete newState[key];
                }
            });
            Object.keys(importedPackages).forEach(key => {
                if (!key) {
                    return;
                }
                newState[key] = importedPackages[key];
            });
            newState.Widgets = importedWidgets;
            return newState;
        });
    }, [products, formId]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let filteredComponents: any = {};
        if (!e.target.value) {
            setList(filteredComponenteList)
            return
        }
        let value = e.target.value.toLowerCase();
        Object.keys(filteredComponenteList).forEach((compType: any) => {
            let componentList: any[] = filteredComponenteList[compType];
            let newcomponentList = componentList && componentList.filter(x => x.label.toLowerCase().includes(value));
            if (newcomponentList.length > 0) {
                filteredComponents[compType] = [...newcomponentList]
            }
        });
        setList(filteredComponents);
    }

    return (
        <React.Fragment>
            <div style={{ margin: '0px' }}>
                <Tabs defaultActiveKey="1" onChange={key => { setActiveTab(key) }} >
                    <TabPane tab={activeTab === "1" ? <Tooltip title="Components"><Component /></Tooltip> : <Tooltip title="Components"><ComponentLight /></Tooltip>} key="1" >
                        <div className={style.search + " row"} >
                            <img src={search} alt="" />
                            <input data-test-id="component_search" type="search" placeholder="Search here..." onChange={handleChange} />
                        </div>
                        <Collapse data-test-id="collapse" bordered={false} defaultActiveKey={['1']}
                            accordion
                            style={{ background: "white" }}
                            expandIcon={(panel: any) => panel.isActive ? <Icon data-test-id="minus" type="minus" /> : <Icon data-test-id="plus" type="plus" />}
                            expandIconPosition="right">
                            {Object.keys(list).map((keys: any, key: number) => {
                                if (list[keys].length) {
                                    return (
                                        <Panel
                                            header={
                                                <div data-test-id="component_body" className={style.component}>
                                                    <div data-test-id="component_header" className={style.componentHeader + ""}>
                                                        <div data-test-id="component_header_name" className={style.name}>{`${keys}`}</div>
                                                    </div>
                                                </div>
                                            } key={key + 1}>
                                            <div className={style.component}>
                                                <div className={style.body}>
                                                    {
                                                        list[keys].map((res: any, index: number) => {
                                                            return (
                                                                <Box data-test-id="filtered_components_list" res={res} canEdit={canEdit} key={index} />
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </Panel>
                                    )
                                } else {
                                    return null
                                }
                            })}
                        </Collapse>
                    </TabPane>
                    {!assetEditMode && <TabPane tab={activeTab === "2" ? <Tooltip title="Layers"><Layer /> </Tooltip> : <Tooltip title="Layers"><LayerLight /></Tooltip>} key="2">
                        <Tree />
                    </TabPane>}
                    {!assetEditMode && <TabPane tab={activeTab === "3" ? <Tooltip title="Assets"><Folder /> </Tooltip> : <Tooltip title="Assets"><FolderLight /></Tooltip>} key="3" >
                        {Object.keys(assets).length === 0 && <div style={{ textAlign: "center", color: "#c2c2c2" }}>No assets found</div>}
                        <div>
                            <div className={style.assetContainer} >
                                {
                                    Object.values(assets).map((asset: any, index: number) => {
                                        if (Object.keys(asset).length === 0) {
                                            return null;
                                        }
                                        const updatedAsset = { ...asset, isAsset: asset && !!asset.assetId, label: asset.json.properties.label || asset.json.label || asset.label }
                                        if (!updatedAsset.isAsset) {
                                            return null;
                                        }
                                        return (
                                            <div className={style.asset} key={index} >
                                                <Box data-test-id="filtered_components_list" res={updatedAsset} canEdit={canEdit} key={index} />
                                                <Tooltip
                                                    className="more"
                                                    onVisibleChange={(value) => {
                                                        if (!value) {
                                                            setSelectedId(null)
                                                        }
                                                    }}
                                                    visible={updatedAsset.id === selectedId}
                                                    placement="topRight"
                                                    overlayClassName="assetTooltip"
                                                    title={
                                                        <AssetTooltip id={updatedAsset.assetId} setSelectedId={setSelectedId} />
                                                    }
                                                    trigger="click"
                                                >
                                                    <MoreIcon className={style.moreIcon} height="16px" onClick={() => setSelectedId(selectedId === asset.id ? null : asset.id)} />
                                                </Tooltip>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </TabPane>}
                </Tabs>
                {/* <div className={style.component}>
                    <div className={style.componentHeader + ""}>
                        <div className={style.name}>Basic components</div>
                        <div className={style.icon}><Icon type="minus" /></div>
                    </div>
                    <div className={style.body + " row"}>
                        {
                            components['basic'].map((res, key) => {
                                return (
                                    <Box res={res} key={key} />
                                )
                            })
                        }
                    </div>
                </div> */}
            </div>
        </React.Fragment>
    )
}

const Box = (props: any) => {
    const { res } = props;
    const [{ isDragging }, drag] = useDrag({
        item: { type: ItemTypes.BOX, ...res },
        // end: (item: { name: string } | undefined, monitor: DragSourceMonitor) => {
        //   const dropResult = monitor.getDropResult();
        //   if (item && dropResult) {
        //     // alert(`You dropped ${item.name} into ${dropResult.name}!`)
        //   }
        // },
        collect: monitor => ({
            isDragging: monitor.isDragging(),
        }),
    })
    const opacity = isDragging ? 0.4 : 1
    return (
        <div data-test-id={`${res.label}_components_list`} className={style.components} ref={(props.canEdit) ? drag : null} style={{ opacity, cursor: 'pointer' }}>
            {/* <img src={res.icon} alt="" /> */}
            {res.icon && <res.icon height='18px' width='18px' color="#505F7B" />}
            <div data-test-id="component_name" className={style.divName}><span className={style.name}>{res.label}</span></div>
        </div>
    )
}


export default Components;
